import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/20/solid';

function ErrorMessage({ message, linkText, linkHref }) {
  const [isVisible, setIsVisible] = useState(false);
  const [currentMessage, setCurrentMessage] = useState('');

  useEffect(() => {
    if (message && message !== currentMessage) {
      // Only update if we have a new message
      setCurrentMessage(message);
      setIsVisible(true);
      
      // Set timer to auto-hide
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 15000); // 15 seconds

      // Clear timeout if component unmounts or new message arrives
      return () => clearTimeout(timer);
    }
  }, [message]); // Trigger only when message prop changes

  const handleClose = () => {
    setIsVisible(false);
    setCurrentMessage(''); // Reset current message to prevent re-show
  };

  if (!isVisible || !message) return null;

  return (
    <div className="border-l-4 border-yellow-400 bg-yellow-50 p-4 m-2">
      <div className="flex justify-between">
        <div className="flex">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-700">
              {message}{' '}
              {linkHref && linkText && (
                <a href={linkHref} className="font-medium text-yellow-700 underline hover:text-yellow-600">
                  {linkText}
                </a>
              )}
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <button onClick={handleClose} className="text-yellow-400 hover:text-yellow-600">
            <XCircleIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
  linkText: PropTypes.string,
  linkHref: PropTypes.string,
};

export default ErrorMessage;